import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './globals.css'
import { injectThemeVariables } from './utils/theme'

// Inject theme variables from .env before rendering
injectThemeVariables();

// Set favicon dynamically from environment variable
const setFavicon = () => {
  const faviconUrl = import.meta.env.VITE_FAVICON_URL;
  if (faviconUrl) {
    const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement || document.createElement('link');
    link.type = 'image/png';
    link.rel = 'icon';
    link.href = faviconUrl;
    if (!document.querySelector("link[rel*='icon']")) {
      document.head.appendChild(link);
    }
  }
};

setFavicon();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
)